import { useEffect, useState } from 'react'
import { primary_color } from '../../../Helper/uiHelper'
import PageHeader from '../../Permissions/PageHeader'
import { request } from '../../../Redux/Sagas/requests/api'
import moment from 'moment'
import { AvField, AvForm } from 'availity-reactstrap-validation'
import { InputForAmount } from '../../Widget/PaymentForm/adminPaymentDetails'
import RefundSuccess from './refundSuccess'
import RefundRejected from './refundRejected'
import Loader from 'react-loaders'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import { useDispatch, useSelector } from 'react-redux'
import { setNotification } from '../../../Redux/Reducers/notificationHandling'
import ApproveRefundPreview from './approveRefundPreview'
import { fetchUpdateApi } from '../../../Redux/Sagas/rootSaga'
import { fetchUpdateApiData } from '../../../Redux/Reducers/CMS'
import { Button } from 'reactstrap'
import { useHistory } from 'react-router-dom'
import { checkIsAdminOrManager, isSuccessResponse } from '../../../helper'

const getSingleData = (item, refundData) => {
  const booking_fields = [
    {
      title: 'Child Name',
      field_id: 'child_name',
      value: item?.item_answer_response_text_first_report + ' ' + item?.item_answer_response_text_second_report,
    },
    {
      title: 'Locker Block',
      field_id: 'child_name',
      value: item?.location?.name,
    },
    {
      title: 'School Name',
      field_id: 'child_name',
      value: refundData?.domain_name,
    },
    {
      title: 'Locker Number',
      field_id: 'child_name',
      value: item?.item?.item_name,
    },
    {
      title: 'Start Rent',
      field_id: 'pre_time',
      value: item?.item_date_time?.from_date && moment(item?.item_date_time?.from_date).format('MMM D  YYYY, hh:mm'),
    },
    {
      title: 'End Rent',
      field_id: 'post_time',
      value: item?.item_date_time?.to_date && moment(item?.item_date_time?.to_date).format('MMM D  YYYY, hh:mm'),
    },
  ]
  return booking_fields
}
const getData = (data, refundData) => {
  const arr = data?.map((item) => getSingleData(item, refundData))
  return arr
}

const toUserMessage = (value, fallback = 'Refund failed. Please try again.') => {
  if (!value) return fallback
  if (typeof value === 'string') {
    const trimmed = value.trim()
    if (trimmed.startsWith('{') || trimmed.startsWith('[')) {
      try {
        const parsed = JSON.parse(trimmed)
        return toUserMessage(parsed.description || parsed.message || parsed.statusDetail || parsed.status_text, fallback)
      } catch (e) {
        return fallback
      }
    }
    return trimmed
  }
  if (typeof value === 'object') {
    return toUserMessage(value.description || value.message || value.status_text || value.statusDetail || value.error, fallback)
  }
  return fallback
}

const ApproveRefund = () => {
  const User = useSelector((state) => state.User)
  const location = useLocation()
  const dispatch = useDispatch()
  const history = useHistory()
  const searchParams = new URLSearchParams(location.search)
  const refund_id = searchParams.get('refund_id')
  const isPreviewEmail = searchParams.get('preview_email')
  const defaultRefundNote = searchParams.get('refund_note')

  const [refundData, setRefundData] = useState()
  const [bookingDetails, setBookingDetails] = useState()
  const [error, setError] = useState()
  const [screenStatus, setScreenStatus] = useState({
    loader: true,
    success: false,
    rejected: false,
    email: false,
    not_found: false,
  })

  const [refundAmount, setRefundAmount] = useState()
  const [refundNote, setRefundNote] = useState()

  useEffect(() => {
    if (defaultRefundNote) {
      setRefundNote(defaultRefundNote)
    }
  }, [])

  useEffect(() => {
    if (!refund_id) {
      setScreenStatus({
        loader: false,
        success: false,
        rejected: false,
        email: false,
        not_found: true,
      })
      return
    }
    request('transaction-info', 'POST', { id: parseInt(refund_id), is_refund: true }).then((res) => {
      setRefundData(res?.data?.data)
      const booking_details = getData(res?.data?.data?.booking_details, res?.data?.data)
      setBookingDetails(booking_details)
      setRefundAmount(res?.data?.data?.transaction_log?.amount)
      if (res?.data?.data?.transaction_log) {
        if (isPreviewEmail) {
          setScreenStatus({
            loader: false,
            success: false,
            rejected: false,
            email: true,
            not_found: false,
          })
        } else {
          setScreenStatus({
            loader: false,
            success: false,
            rejected: false,
            email: false,
            not_found: false,
          })
        }
      } else {
        setScreenStatus({
          loader: false,
          success: false,
          rejected: false,
          email: false,
          not_found: true,
        })
      }
    })
  }, [])

  useEffect(() => {
    if (parseInt(refundAmount) > refundData?.payment?.amount) {
      setError('Refund amount should be less than total amount')
    } else {
      setError()
    }
  }, [refundAmount])

  const onDeclineRequest = () => {
    setScreenStatus({
      loader: true,
      success: false,
      rejected: false,
      email: false,
      not_found: false,
    })
    request('reject-refund', 'POST', { id: parseInt(refund_id), refund_note: refundNote }).then((res) => {
      if (res?.status === 200 || res?.status === 202) {
        setScreenStatus({
          loader: false,
          success: false,
          rejected: true,
          email: false,
          not_found: false,
        })
        dispatch(fetchUpdateApiData())
      } else {
        setScreenStatus({
          loader: false,
          success: false,
          rejected: false,
          email: false,
          not_found: false,
        })
        dispatch(setNotification({ type: 'error', message: 'Something went wrong!' }))
      }
    })
  }

  const onGoBack = () => {
    let url = '/purchase-list?' + 'selected_ids=' + refundData?.payment?.booking_id + '&search_field=booking_id'
    history.push(url)
  }

  const onApproveRequest = () => {
    if (!refundNote) {
      dispatch(setNotification({ type: 'error', message: 'Please enter refund note!' }))
      return
    }
    setScreenStatus({
      loader: true,
      success: false,
      rejected: false,
      email: false,
      not_found: false,
    })
    request('payments/refund', 'POST', {
      referenceTransactionId: refundData?.payment?.sage_pay_transaction_id,
      amount: parseFloat(refundAmount),
      description: refundNote,
      id: parseInt(refund_id),
    }).then((res1) => {
      if (res1?.data?.status === '0000') {
        request('update-refund-status', 'POST', { id: parseInt(refund_id), refund_note: refundNote, refund_amount: refundAmount }).then((res) => {
          if (res?.status === 200 || res?.status === 202) {
            setScreenStatus({
              loader: false,
              success: true,
              rejected: false,
              email: false,
              not_found: false,
            })
          } else {
            setScreenStatus({
              loader: false,
              success: false,
              rejected: false,
              email: false,
              not_found: false,
            })
            dispatch(setNotification({ type: 'error', message: 'Something went wrong!' }))
          }
          dispatch(fetchUpdateApiData())
        })
      } else {
        dispatch(
          setNotification({
            type: 'error',
            message: toUserMessage(res1?.data?.status_text || res1?.data?.message, 'Refund failed. Please try again.'),
          })
        )
        setScreenStatus({
          loader: false,
          success: false,
          rejected: false,
          email: false,
          not_found: false,
        })
      }
    })
  }

  if (screenStatus?.success) return <RefundSuccess onGoBack={onGoBack}></RefundSuccess>
  if (screenStatus?.rejected) return <RefundRejected onGoBack={onGoBack}></RefundRejected>
  if (screenStatus?.email)
    return (
      <ApproveRefundPreview
        payload={{ id: parseInt(refund_id), refund_note: refundNote, refund_amount: refundAmount }}
        onCancelPreview={() => {
          setScreenStatus({
            loader: false,
            success: false,
            rejected: false,
            email: false,
            not_found: false,
          })
        }}></ApproveRefundPreview>
    )
  if (screenStatus?.loader)
    return (
      <div className='d-flex flex-column align-items-center'>
        <PageHeader text={'Refund'}></PageHeader>
        <div style={{ marginTop: '3rem' }}>
          <Loader type='ball-pulse' color='blue' />
        </div>
      </div>
    )
  if (screenStatus?.not_found)
    return (
      <div>
        <PageHeader text={'Refund'}></PageHeader>
        <div className='d-flex flex-column justify-content-center align-items-center'>
          <div>
            <img src='not_found.png' style={{ width: '20rem' }}></img>
          </div>
          <div>Link is expired.</div>
        </div>
      </div>
    )
  if (checkIsAdminOrManager(User?.user?.role ?? User?.publicUser?.role)) {
    return (
      <div>
        <PageHeader text={'Refund'}></PageHeader>
        <Button
          color='dark'
          className='mb-4 mt-4'
          onClick={() => {
            window.close()
            // onGoBack()
            // onCancelPreview()
            // setIsPaymentRequestPreviewOpen(false)
          }}>
          {' '}
          Close
        </Button>
        <div style={{ padding: '0rem 4rem' }} className='mt-4 mb-5'>
          <div className='font-weight-bold body1' style={{ color: primary_color }}>
            {refundData?.booking_details?.[0]?.booking_reservation_id}: Refund Requested by {refundData?.refund_requested}
          </div>
          <div className='my-3'>
            <div className='font-weight-bold subtitle1 mb-4' style={{ color: primary_color }}>
              Booking Detail
            </div>
            {bookingDetails?.map((item) => {
              return (
                <>
                  <div className='row mb-5'>
                    {item?.map((field) => {
                      return (
                        <>
                          <div className='col-md-6'>
                            <div className='d-flex row mb-2'>
                              <div className='font-weight-bold subtitle1 col-md-4'>{field?.title} : </div>
                              <div className='subtitle1 col-md-8'>&nbsp;{field?.value}</div>
                            </div>
                          </div>
                        </>
                      )
                    })}
                  </div>
                  <hr></hr>
                </>
              )
            })}
          </div>
          <div className='my-3'>
            <div className='font-weight-bold subtitle1 mb-2' style={{ color: primary_color }}>
              Type
            </div>
            <div className='subtitle1 mb-4'>
              {refundData?.transaction_log?.refund_type?.name || refundData?.transaction_log?.type_label || refundData?.transaction_log?.type}
            </div>
          </div>

          <div className='my-3'>
            <div className='font-weight-bold subtitle1 mb-2' style={{ color: primary_color }}>
              Reason
            </div>
            <div className='subtitle1 mb-4' dangerouslySetInnerHTML={{ __html: refundData?.transaction_log?.reason }}></div>
          </div>

          {Array.isArray(refundData?.lost_unit_ids) && refundData.lost_unit_ids.length > 0 && (
            <div className='my-3'>
              <div className='font-weight-bold subtitle1 mb-2' style={{ color: primary_color }}>
                Lockers to mark Lost on approval
              </div>
              <div className='subtitle1 mb-4'>
                {(refundData?.booking_details || [])
                  .filter((unit) => refundData.lost_unit_ids.includes(unit.id) || refundData.lost_unit_ids.includes(String(unit.id)))
                  .map((unit) => {
                    const lockerNo = unit?.item?.item_name || unit?.item_name_report
                    const block = unit?.location?.name
                    return (
                      <div key={unit.id}>
                        Locker {lockerNo}
                        {block ? ` — ${block}` : ''}
                      </div>
                    )
                  })}
              </div>
            </div>
          )}

          <div className='my-3'>
            <div className='font-weight-bold subtitle1 mb-2' style={{ color: primary_color }}>
              Refund Note
            </div>
            <AvForm>
              <AvField name='refund_note' value={refundNote} type='textarea' onChange={(e) => setRefundNote(e.target.value)}></AvField>
            </AvForm>
          </div>

          <div className='my-3' style={{ width: '20rem' }}>
            <div className='font-weight-bold subtitle1 mb-2' style={{ color: primary_color }}>
              Charges
            </div>
            <InputForAmount
              id='refund'
              value={refundAmount}
              label='Refund'
              onChangeValue={(val) => {
                setRefundAmount(val)
              }}></InputForAmount>
            <InputForAmount
              id='total_amount'
              value={parseFloat(refundData?.payment?.amount)}
              isDisabled={true}
              label='Total Amount'
              onChangeValue={() => {}}></InputForAmount>
          </div>
          {error && (
            <div class='alert alert-danger my-4' role='alert'>
              {error}
            </div>
          )}
          <div className='my-5 d-flex '>
            <button
              className='btn rounded-pill mt-2 text-danger border-danger mr-3'
              type='button'
              onClick={(e) => {
                onDeclineRequest()
              }}
              style={{ fontWeight: 700, width: '12rem' }}>
              Decline
            </button>
            <button
              className='btn text-white rounded-pill mt-2 mr-3'
              disabled={!!error}
              type='submit'
              onClick={() => {
                onApproveRequest()
              }}
              style={{ background: primary_color, fontWeight: 700, width: '12rem' }}>
              Approve
            </button>
            <button
              className='btn text-white rounded-pill mt-2'
              disabled={!!error}
              type='submit'
              style={{ background: primary_color, fontWeight: 700, width: '14rem' }}
              onClick={() => {
                // window.open(`refund-approve?refund_id=${refund_id}&preview_email=true&refund_note=${refundNote}`)
                setScreenStatus({
                  loader: false,
                  success: false,
                  rejected: false,
                  email: true,
                  not_found: false,
                })
              }}>
              Preview Email
            </button>
          </div>
        </div>
      </div>
    )
  } else {
    return (
      <div>
        <PageHeader text={'Refund'}></PageHeader>
        <div className='d-flex flex-column justify-content-center align-items-center'>
          <div>
            <img src='not_found.png' style={{ width: '20rem' }}></img>
          </div>
          <div className='subtitle1'>You don't have permission to approve/reject the refund</div>
          <div className='subtitle1'>Please contact admin.</div>
        </div>
      </div>
    )
  }
}

export default ApproveRefund
